import { Component, Story, Knobs, MobileHeaderAccent } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  heading: {
    default: 'My Mobile Header',
    editor: 'textbox',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(MobileHeaderAccent),
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  showBackButton: {
    default: false,
    editor: 'checkbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A mobile header element with various attributes',
  coreComponent_v3: {
    html: `<tag3-mobile-header {{...knobs}} ></tag3-mobile-header>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<TagMobileHeader {{...knobs}} />`,
    knobs: {
      ...PlaygroundKnobs,
    },
  },
};

const ActionsStory: Story = {
  title: 'With avatar',
  description: 'A mobile header element with an example avatar included in the "actions" slot',
  coreComponent_v3: {
    html: `<tag3-mobile-header {{...knobs}}>
  <div slot="actions">
    <tag3-avatar 
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px' 
      placeholder='GS'>
    </tag3-avatar>
  </div>
</tag3-mobile-header>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<TagMobileHeader {{...knobs}}>
  <div slot="actions">
    <Tag3Avatar 
      slot="actions" 
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px' placeholder='GS' 
    />
  </div>
</TagMobileHeader>`,
    knobs: {
      ...PlaygroundKnobs,
    },
  },
};

const SearchStory: Story = {
  title: 'With custom content',
  description:
    'A mobile header element with an example search box below the main header in the "below" slot',
  coreComponent_v3: {
    html: `<tag3-mobile-header {{...knobs}}>
  <div slot="below">
    <tag3-searchbox slot="bar" placeholder='Search...' device='mobile'></tag3-searchbox>
  </div>
</tag3-mobile-header>`,
    knobs: {
      ...PlaygroundKnobs,
      heading: {
        default: '',
        editor: 'textbox',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<TagMobileHeader {{...knobs}}>
  <div slot="below">
    <Tag3Searchbox placeholder='Search...' delay={500} device='mobile' />
  </div>
</TagMobileHeader>`,
    knobs: {
      ...PlaygroundKnobs,
      heading: {
        default: '',
        editor: 'textbox',
      },
    },
  },
};

const CustomStyleStory: Story = {
  title: 'With custom Style',
  description: 'A mobile header with custom style',
  coreComponent_v3: {
    html: `<tag3-mobile-header {{...knobs}}>
  <div slot="below">
    <tag3-searchbox slot="bar" placeholder='Search...' device='mobile'></tag3-searchbox>
  </div>
</tag3-mobile-header>`,
    knobs: {
      ...PlaygroundKnobs,
      headerStyle: {
        default: '{"padding-top": "20px"}',
        editor: 'multilinetextbox',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<TagMobileHeader {{...knobs}}>
  <div slot="below">
    <Tag3Searchbox placeholder='Search...' delay={500} device='mobile' />
  </div>
</TagMobileHeader>`,
    knobs: {
      ...PlaygroundKnobs,
      headerStyle: {
        default: '{"padding-top": "20px"}',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
    },
  },
};

export const TagMobileHeaderDocs: Component = {
  type: 'component',
  name: 'mobile-header',
  description: 'Renders a mobile header element. This is for use on a mobile device.',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'heading',
      description: 'The text to display in the header',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The accent colour for background',
      type: 'white | access | atoll | plum | keppel | dolphinblue | tango',
      default: 'white',
    },
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'showBackButton',
      description: 'Toggles whether to include a back arrow in the header',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'headerStyle',
      description: ' A CSS JSON string to apply to the internal header element',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'mobileHeaderBackClick',
      description: 'When the back button is shown, triggers when the back button is clicked',
      parameters: [],
    },
  ],
  methods: [],
  stories: [PlaygroundStory, ActionsStory, SearchStory, CustomStyleStory],
};
